import Decimal from "decimal.js";

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 4,
});

const integerFormatter = new Intl.NumberFormat("en-US");

export function formatUsd(value) {
  if (value == null || value === "") return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return usdFormatter.format(n);
}

export function formatDecimal(value, maxFractionDigits = 4) {
  if (value == null || value === "") return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: maxFractionDigits,
  }).format(n);
}

export function formatInteger(value) {
  if (value == null) return "—";
  return integerFormatter.format(value);
}

export function sumDecimalStrings(values) {
  return values
    .filter((v) => typeof v === "string" && v !== "")
    .reduce((acc, v) => acc.plus(v), new Decimal(0))
    .toString();
}

export function truncateAddress(address, head = 6, tail = 4) {
  if (!address) return "";
  if (address.length <= head + tail + 2) return address;
  return `${address.slice(0, head)}…${address.slice(-tail)}`;
}

// BSC explorer URL — only for 0x-prefixed 40-hex addresses, else null.
export function bscAddressUrl(value) {
  return /^0x[a-fA-F0-9]{40}$/.test(value || "") ? `https://bscscan.com/address/${value}` : null;
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

export { numberFormatter };
